
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","enable-background":"new 0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M456.348,0H55.652C24.966,0,0,24.966,0,55.652v400.696C0,487.034,24.966,512,55.652,512h400.696 C487.034,512,512,487.034,512,456.348V55.652C512,24.966,487.034,0,456.348,0z M33.391,55.652 c0-12.275,9.986-22.261,22.261-22.261h183.652v74.026L107.418,239.304H33.391V55.652z M239.304,478.609H55.652 c-12.275,0-22.261-9.986-22.261-22.261V272.696h74.026l131.887,131.887V478.609z M137.944,256L256,137.944L374.056,256 L256,374.056L137.944,256z M478.609,456.348c0,12.275-9.986,22.261-22.261,22.261H272.696v-74.026l131.887-131.887h74.026V456.348 z M478.609,239.304h-74.026L272.696,107.418V33.391h183.652c12.275,0,22.261,9.986,22.261,22.261V239.304z"}})])
          )
        }
      }
    